import React, { useCallback, useEffect, useState } from "react";
import "./LineupEditor.css";
import LineupEditorPlayerSelect from "./LineupEditorPlayerSelect";
import { commitMutation } from "react-relay";
import relayEnvironment from "../../../../../../../RelayEnvironment";
import { COMMIT_PLAYER_CHANGES } from "../../../SelectPlayers/mutations/CommitPlayerSelectionChanges";
import { COMMIT_LINEUP_EDITS } from "./mutations/CommitLineupEdits";
import Overlay from "../../../../../../Overlay";

export default function LineupEditor(props) {
  const [viewingLineup, setViewingLineup] = useState(true);
  const [lineupPlayers, setLineupPlayers] = useState(props.lineup.players);
  const [editIndex, setEditIndex] = useState(undefined);
  const [lineupUpdates, setLineupUpdates] = useState({});
  const [changesMade, setChangesMade] = useState(false);

  const escFunction = useCallback((event) => {
    if (event.keyCode === 27) {
      //Close when esc is pressed
      closeEditor(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", escFunction, false);

    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, []);

  function updateLineup(index, player) {
    setChangesMade(true);

    setLineupUpdates({ ...lineupUpdates, [index]: player });

    setViewingLineup(true);

    setEditIndex(undefined);
  }

  function editPlayer(index) {
    setEditIndex(index);
    setViewingLineup(false);
  }

  function cancelPlayerSelect() {
    setViewingLineup(true);
  }

  function closeEditor(changesMade) {
    if (viewingLineup) {
      setLineupUpdates({});

      props.closeEditor(changesMade);
    } else {
      setViewingLineup(true);
      setEditIndex(undefined);
    }
  }

  function handleCancel(e) {
    e.preventDefault();

    closeEditor(false);
  }

  function getAccurateSlatePlayer(player, index) {
    return index in lineupUpdates
      ? lineupUpdates[index]
      : player.player.slatePlayer;
  }

  function totalSalary() {
    let totalSalary = 0;

    props.lineup.players.map((player, index) => {
      const slatePlayer = getAccurateSlatePlayer(player, index);

      totalSalary += slatePlayer.salary;
    });

    if (editIndex !== undefined) {
      const editingSlatePlayer = getAccurateSlatePlayer(
        props.lineup.players[editIndex],
        editIndex
      );

      totalSalary -= editingSlatePlayer.salary;
    }

    return totalSalary;
  }

  function totalPercOwn() {
    let totalPerc = 0;

    props.lineup.players.map((player, index) => {
      const slatePlayer = getAccurateSlatePlayer(player, index);

      const playerOwn = slatePlayer.gupPercProj;

      totalPerc += playerOwn ? playerOwn : 0;
    });

    if (editIndex !== undefined) {
      const editingSlatePlayer = getAccurateSlatePlayer(
        props.lineup.players[editIndex],
        editIndex
      );

      const playerOwn = editingSlatePlayer.gupPercProj;

      totalPerc -= playerOwn ? playerOwn : 0;
    }

    return totalPerc;
  }

  function handleSave(e) {
    e.preventDefault();

    const rosterSlots = [];
    const playerIdCheck = [];
    let passedDupeCheck = true;

    props.lineup.players.map((player, index) => {
      const slatePlayer = getAccurateSlatePlayer(player, index);

      if (playerIdCheck.includes(slatePlayer.id)) {
        passedDupeCheck = false;
      }

      playerIdCheck.push(slatePlayer.id);

      rosterSlots.push({
        slatePlayerId: slatePlayer.id,
        lineupRosterSlotId: player.lineupRosterSlot.id,
      });
    });

    if (!passedDupeCheck) {
      alert(
        "You have selected the same player more than once. Please fix this error and then try again."
      );
      return;
    }

    commitMutation(relayEnvironment, {
      mutation: COMMIT_LINEUP_EDITS,
      variables: {
        input: {
          greenMachineLineupId: props.lineup.id,
          rosterSlots: rosterSlots,
        },
      },
      onCompleted: (content, errors) => {
        if (!errors) {
          closeEditor(true);
        }
      },
      onError: (error) => {
        console.log(error);
      },
    });
  }

  return (
    <Overlay show={props.showEditor}>
      <div className="lineup-editor-container">
        <button onClick={handleCancel}>
          {viewingLineup
            ? "Exit Editor Without Saving"
            : "Cancel Player Select"}
        </button>{" "}
        {viewingLineup ? (
          <button onClick={handleSave}>Save Changes</button>
        ) : null}
        <p>
          TOTAL SALARY: ${totalSalary()} (${50000 - totalSalary()} remaining)
        </p>
        <div className="lineup-editor-players">
          {viewingLineup || editIndex === undefined ? (
            <>
              {lineupPlayers.map((player, index) => {
                const slatePlayer = getAccurateSlatePlayer(player, index);

                return (
                  <div key={player.id} className="lineup-editor-player">
                    <p>
                      {player.lineupRosterSlot.rosterSlot.name}{" "}
                      {slatePlayer.player.name}{" "}
                      {slatePlayer.gupPercProj ? (
                        <span>
                          <strong>({slatePlayer.gupPercProj}% proj own)</strong>
                        </span>
                      ) : null}
                      <br />${slatePlayer.salary}
                    </p>

                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        editPlayer(index);
                      }}
                    >
                      Edit
                    </button>
                  </div>
                );
              })}

              <p>
                <strong>Total Ownership: {totalPercOwn()}%</strong>
              </p>
            </>
          ) : (
            <LineupEditorPlayerSelect
              cancel={cancelPlayerSelect}
              index={editIndex}
              updateLineup={updateLineup}
              remainingSalary={50000 - totalSalary()}
              rosterSlotId={
                props.lineup.players[editIndex].lineupRosterSlot.rosterSlot.id
              }
            />
          )}

          {}
        </div>
      </div>
    </Overlay>
  );
}
